var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row ",staticStyle:{"justify-content":"center !important"}},[_c('div',{staticClass:"col-md-5 col-xs-12 pa-md-8"},[_c('RAQForm',{attrs:{"comp-data":_vm.raqData}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }